export default "__VITE_ASSET__BWkzzqVE__"